import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CategoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"category"}/>
}
